import React, { useEffect } from "react";
import { StaticToolbar } from "./basic/Toolbar";
import { IToolbarElement, Toolbar } from "dhx-suite";
import history from "../services/history";
import { AppModel } from "../models";

interface EmbeddedContainerProps {
    mode: "result" | "jsCode" | "htmlCode";
    state: AppModel;
    children: JSX.Element;
}

const toolbarControls: IToolbarElement[] = [
    {
        id: "basicModeLink",
        type: "customHTML",
        html: `<a class="st-link-basemode__embedded" target="_blank"><span class="mdi mdi-launch"></span> Edit in Snippet tool</a>`,
    },
    {
        type: "spacer"
    },
    {
        id: "js",
        css: `st-mode-tab__embedded`,
        value: "JavaScript"
    },
    {
        id: "html",
        css: `st-mode-tab__embedded`,
        value: "HTML"
    },
    {
        id: "result",
        css: `st-mode-tab__embedded`,
        value: "Live preview"
    },
    {
        type: "spacer"
    },
    {
        id: "search",
        value: "Search",
        icon: "mdi mdi-magnify",
        css: "st-toolbar--button__search"
    },
];

const responsiveToolbarControls = [
    {
        id: "basicModeLink",
        type: "customHTML",
        html: `<a class="st-link-basemode__embedded" target="_blank"><span class="mdi mdi-launch"></span></a>`,
    },
    {
        type: "spacer"
    },
    {
        id: "js",
        css: `st-mode-tab__embedded`,
        value: "JavaScript"
    },
    {
        id: "html",
        css: `st-mode-tab__embedded`,
        value: "HTML"
    },
    {
        id: "result",
        css: `st-mode-tab__embedded`,
        value: "Live preview"
    },
    {
        type: "spacer"
    }
];

export const EmbeddedContainer = ({
    mode,
    state,
    children
}: EmbeddedContainerProps) => {
    const [toolbar, setToolbar] = React.useState<Toolbar>();
    const responsive = window.innerWidth <= 576;
    useEffect(() => {
        if (toolbar) {
            toolbar.data.update("basicModeLink", {
                html: `<a class="st-link-basemode__embedded" target="_blank" href="/${state.snippet.id}"><span class="mdi mdi-launch"></span> ${responsive ? "" : "Edit in Snippet tool"}</a>`
            });
            toolbar.data.update("js", {
                css: `st-mode-tab__embedded ${mode === "jsCode" ? "active" : ""}`
            });
            toolbar.data.update("html", {
                css: `st-mode-tab__embedded ${mode === "htmlCode" ? "active" : ""}`
            });
            toolbar.data.update("result", {
                css: `st-mode-tab__embedded ${mode === "result" ? "active" : ""}`
            });
        }
    }, [toolbar, mode, state.snippet.id]);

    return <main className="st-main-container__embedded">
        <StaticToolbar
            className="st-toolbar"
            controls={responsive ? responsiveToolbarControls : toolbarControls}
            onClick={id => {
                if (id === "result" || id === "js" || id === "html") {
                    history.push(`/${state.snippet.id}?mode=${id}`);
                }
                if (id === "search") {
                    window.open(`https://snippet.dhtmlx.com/all`, "_blank");
                }
            }}
            onToolbarMounted={setToolbar}
        />
        <div className="st-main-container--title__embedded">
           <span>
               {state.snippet.title || ""}
            </span>
            <div className="st-tag--wrapper">
                {state.snippet.tagsIds
                    .filter(tId => state.tags.has(tId))
                    .map(tId =>
                        <span
                        className="st-tag st-tag__embedded"
                        onClick={() => window.open(`https://snippet.dhtmlx.com/all?text=%23${state.tags.get(tId)}`, "_blank")}
                        >
                    {state.tags.get(tId)}
                    </span>
                )}
            </div>
        </div>
        {children}
    </main>;
};
